import axios from 'axios'
import { useEffect, useState } from 'react'
import { baseUrl } from '../../../baseUrl'
import { Link } from 'react-router-dom'
import { Hourglass } from 'react-loader-spinner'

const XII = () => {
  const [courses, setCourses] = useState([])
  const [loading,setLoading] =useState(true);

    const getCourses = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${baseUrl}/course/active/by-class?className=Class XII`)
            setCourses(response.data)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        getCourses();
    }, [])
  return (
    <div style={{minHeight:'50vh'}}>
      <section className=" course-grid">
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-lg-7">
                            <div className="section-heading center-heading mt-2">
                                <h3>Class XII Courses</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                      {
                          loading &&
                          <div className='d-flex justify-content-center'>
                                  <Hourglass
                                      visible={true}
                                      height="80"
                                      width="80"
                                      ariaLabel="hourglass-loading"
                                      wrapperStyle={{}}
                                      wrapperClass=""
                                      colors={['#8000df', '#72a1ed']}
                                  />
                          </div>
                      }
                      {
                          !loading && courses.length < 1 &&
                          <h4 className='text-center'>Coming Soon...</h4>
                      }
                        {
                            !loading&&courses.length>0&&
                            courses.map((c, i) =>
                                <div key={i} className="col-lg-4 col-md-6">
                                    <div className="course-block">
                                        <div className="course-img">
                                            <img src={`${process.env.REACT_APP_API_URL}${c.image}`} alt="" className="img-fluid" width={'100%'}/>
                                            <span className="course-label">{c.className}</span>
                                        </div>

                                        <div className="course-content">
                                            <span className="course-price text-decoration-line-through fs-5 mr-4">₹{c.originalPrice}</span>
                                            <span className="course-price fs-4">₹{c.price}</span>

                                            <h4><a href="#">{c.title}</a></h4>
                                            {/* <div className="rating">
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <a href="#"><i className="fa fa-star"></i></a>
                                                <span>(5.00)</span>
                                            </div> */}
                                            <p>{c.description}</p>

                                            <div className="course-footer d-lg-flex align-items-center justify-content-between">
                                                <div className="course-meta">
                                                    <span className="course-duration"><i className="bi bi-badge3"></i>{c.tests} Tests</span>
                                                </div>

                                                <div className="buy-btn"><Link to={`/course/${c.courseID}`} className="btn btn-main-2 btn-small">Details</Link></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                        }
                    </div>


                    {/* <div className="row">
                        <div className="col-lg-12">
                            <nav className="blog-pagination text-center">
                                <ul>
                                    <li className="page-num active"><a href="#">1</a></li>
                                    <li className="page-num"><a href="#">2</a></li>
                                    <li className="page-num"><a href="#">3</a></li>
                                </ul>
                            </nav>
                        </div>
                    </div> */}
                </div>
            </section>
    </div>
  )
}

export default XII
